<!-- TopBar para mobile y tablet -->
<header
  class="bg-white text-gray-700 py-3 px-4 xl:hidden relative"
  role="banner"
>
  <div class="flex items-center justify-between gap-2 text-sm">
    <a
      [href]="
        selectedStore()?.phone ? 'tel:+504' + selectedStore()?.phone : '#'
      "
      (click)="handlePhoneClick($event)"
      class="flex items-center space-x-2 border border-gray-300 rounded-md px-3 py-2 transition-colors"
      [attr.aria-label]="'Llamar al ' + (selectedStore()?.phone || '2509-7350')"
    >
      <img
        src="/allas-icons/telephone-v2.svg"
        alt="Icono de teléfono"
        width="24"
        height="24"
        class="w-auto h-4"
      />
    </a>
    <ng-container
      *ngTemplateOutlet="
        marketingMessage;
        context: {
          icon: '/allas-icons/battery.svg',
          text: 'Diagnóstico e Instalación GRATIS en Baterías',
          iconClass: 'w-auto h-3',
          textClass: 'text-[10px] font-bold text-appPrimary-500 fs-condensed'
        }
      "
    ></ng-container>
    <a
      href="https://wa.me/50422834540?text=Hola,%20necesito%20cotizar%20un%20producto.%20¿Podrían%20ayudarme?"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center space-x-2 border border-gray-300 rounded-md px-3 py-2 transition-colors"
      aria-label="Contactar por WhatsApp al 2283-4540"
    >
      <img
        src="/allas-icons/whatsapp.svg"
        alt="Icono de WhatsApp"
        width="24"
        height="24"
        class="w-auto h-4"
      />
    </a>
    <!-- A solicitud del cliente se quita el mensaje de envío gratis "temporalmente" pero quien sabe que tan temporal.... -->
    <!-- <ng-container
      *ngTemplateOutlet="
        marketingMessage;
        context: {
          icon: '/allas-icons/truck.svg',
          text: 'Envío GRATIS +Lps 1,000',
          iconClass: 'w-5 h-4',
          textClass: 'text-[10px] font-bold text-appPrimary-500 fs-condensed'
        }
      "
    ></ng-container> -->
  </div>
</header>

<!-- TopBar para desktop -->
<header
  class="bg-white text-white py-3 px-4 hidden xl:block relative"
  role="banner"
>
  <div class="mx-2">
    <div class="flex items-center justify-between w-full text-sm">
      <!-- Logo y Mensajes de Mercadeo -->
      <div class="flex items-center flex-auto gap-8">
        <!-- Logo de Allas -->
        <a
          href="/"
          class="relative flex items-center justify-start"
          aria-label="Ir a página principal de ALLAS REPUESTOS"
        >
          <img
            src="/logos/default-low-profile.webp"
            alt="ALLAS REPUESTOS - Repuestos automotrices"
            width="160"
            height="45"
            loading="eager"
            class="aspect-[1280/360] transition-transform duration-300 hover:scale-105 rounded-md"
          />
        </a>

        <span
          class="text-sm font-bold text-nowrap ml-3 text-red-600 hover:text-red-800"
        >
          ¡Ayudamos a mover el mundo!
        </span>

        <!-- Mensajes de Mercadeo -->
        <div class="flex items-center justify-start gap-2 flex-auto">
          <div class="flex items-center font-bold gap-8">
            <ng-container
              *ngTemplateOutlet="
                marketingMessage;
                context: {
                  icon: '/allas-icons/battery.svg',
                  text: 'Diagnóstico e Instalación GRATIS en Baterías',
                  iconClass: 'w-auto h-6',
                  textClass:
                    'text-sm font-bold text-appPrimary-500 hover:text-appPrimary-800'
                }
              "
            ></ng-container>
            <!-- A solicitud del cliente se quita el mensaje de envío gratis "temporalmente" pero quien sabe que tan temporal.... -->
            <!-- <ng-container
              *ngTemplateOutlet="
                marketingMessage;
                context: {
                  icon: '/allas-icons/truck.svg',
                  text: 'Envío GRATIS +Lps 1,000',
                  iconClass: 'w-auto h-6',
                  textClass:
                    'font-xs text-appPrimary-500 hover:text-appPrimary-800'
                }
              "
            ></ng-container> -->
          </div>
        </div>
      </div>

      <!-- Botones de contacto e iniciar sesión -->
      <nav
        class="flex items-center justify-end gap-2 flex-auto"
        aria-label="Contacto y usuario"
      >
        <!-- Botón de llamada -->
        <div class="flex items-center">
          <a
            [href]="
              selectedStore()?.phone ? 'tel:+504' + selectedStore()?.phone : '#'
            "
            (click)="handlePhoneClick($event)"
            class="flex items-center space-x-2 text-gray-700 hover:text-allasRed px-4 py-2 transition-colors"
            [attr.aria-label]="
              'Llamar al ' + (selectedStore()?.phone || '2283-4340')
            "
          >
            <img
              src="/allas-icons/telephone-v2.svg"
              alt="Icono de teléfono"
              width="24"
              height="24"
              class="w-auto h-6"
            />
            <span class="hidden xl:inline font-light fs-condensed">
              @if (selectedStore()?.phone) {
              {{ selectedStore()?.phone }}
              } @else {
              <span class="text-gray-500 italic">Selecciona una tienda</span>
              }
            </span>
          </a>
        </div>

        <!-- Menú de usuario -->
        <allas-user-menu></allas-user-menu>

        <!-- WhatsApp -->
        <div class="flex items-center">
          <a
            href="https://wa.me/50422834540?text=Hola,%20necesito%20cotizar%20un%20producto.%20¿Podrían%20ayudarme?"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center space-x-2 text-gray-700 hover:text-allasRed px-4 py-2 transition-colors"
            aria-label="Contactar por WhatsApp al 2283-4540"
          >
            <img
              src="/allas-icons/whatsapp.svg"
              alt="Icono de WhatsApp"
              width="24"
              height="24"
              class="w-auto h-6 text-gray-700"
            />
            <span class="hidden xl:inline font-light fs-condensed">
              2283-4540
            </span>
          </a>
        </div>
      </nav>
    </div>
  </div>
</header>

<!-- Diálogo de selección de sucursal -->
<p-dialog
  [(visible)]="showStoreDialog"
  header="Selecciona una sucursal"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '90vw', maxWidth: '800px' }"
  (onHide)="handleDialogClose()"
>
  <allas-mi-tienda
    (onClose)="handleDialogClose()"
    (onStoreSelect)="handleStoreSelect($event)"
  >
  </allas-mi-tienda>
</p-dialog>

<!-- Templates reutilizables -->
<ng-template
  #marketingMessage
  let-icon="icon"
  let-text="text"
  let-iconClass="iconClass"
  let-textClass="textClass"
>
  <div class="flex items-center gap-2">
    <img
      src="{{ icon }}"
      alt="Icono de mercadeo"
      width="24"
      height="24"
      loading="lazy"
      class="{{ iconClass }}"
    />
    <span class="{{ textClass }}">{{ text }}</span>
  </div>
</ng-template>
